import { render } from "./staffs.vue?vue&type=template&id=2dd7fb42"
import script from "./staffs.vue?vue&type=script&lang=js"
export * from "./staffs.vue?vue&type=script&lang=js"

import "./staffs.vue?vue&type=style&index=0&id=2dd7fb42&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__